// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Select from "react-select"; // 1. Import React Select
// import "../css/kycformnew.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCheck, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

// export default function CustomerKyc() {
//   const dispatch = useDispatch();

//   const [filterValue, setFilterValue] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [userDetails, setUserDetails] = useState(null);
//   const [uploadedKyc, setUploadedKyc] = useState([]);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [customerByBranch, setCustomerByBranch] = useState([]);

//   const { list: data } = useSelector((state) => state.employeeReport);

//   useEffect(() => {
//     dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
//   }, [dispatch]);

//   // Employee options formatting for react-select
//   const employeeOptions = data
//     ? data.map((emp) => ({
//         value: emp.id,
//         label: `${emp.fullName} - ${emp.id}`,
//       }))
//     : [];

//   // Customer options formatting for react-select
//   const customerOptions = customerByBranch.map((customer) => ({
//     value: customer.userId,
//     label: `${customer.fullName} - ${customer.userId}`,
//   }));

//   useEffect(() => {
//     const fetchAllCustomersInBranch = async () => {
//       if (!selectedEmployee) {
//         setCustomerByBranch([]);
//         setFilterValue(null); // ✅ Fixed: Use null instead of ""
//         setUserDetails(null);
//         setUploadedKyc([]);
//         return;
//       }

//       // Jab naya employee select ho, tab purane customer ka data clear karein
//       setFilterValue(null);
//       setUserDetails(null);
//       setUploadedKyc([]);

//       try {
//         const superAdminId = localStorage.getItem("adminuserId") || "14";
//         const res = await axios.get("https://payyug.in/api/customers", {
//           params: {
//             superAdminId,
//             branchId: selectedEmployee.value, // react-select ka .value use karein
//             limit: 1000,
//           },
//         });
//         setCustomerByBranch(res?.data?.data || []);
//       } catch (err) {
//         console.error("Error fetching branch customers:", err);
//         setCustomerByBranch([]);
//       }
//     };
//     fetchAllCustomersInBranch();
//   }, [selectedEmployee]);

//   const handleSearch = async () => {
//     if (!filterValue) {
//       alert("Please select a customer.");
//       return;
//     }

//     try {
//       const superAdminId = localStorage.getItem("adminuserId") || "14";
//       const response = await axios.get(
//         "https://payyug.in/api/customers-get-userId",
//         {
//           params: {
//             superAdminId,
//             branchId: selectedEmployee.value,
//             userId: filterValue.value, // react-select object se value nikaali
//           },
//         },
//       );

//       const user = response.data.data;

//       if (user) {
//         setUserDetails({
//           userId: user.userId,
//           Id: user.id,
//           name: user.fullName,
//           pan: user.panNumber,
//           aadhaar: user.aadhaarNumber,
//           mobile: user.mobileNumber,
//           dob: user.dateOfBirth?.slice(0, 10),
//           superAdminId: user.superAdminId,
//           createdId: user.branchId,
//         });

//         const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
//           params: {
//             userId: user.userId,
//             superAdminId: user.superAdminId,
//             createdId: user.branchId,
//           },
//         });
//         setUploadedKyc(kycResponse.data.documents || []);
//       } else {
//         alert("Customer details not found.");
//       }
//     } catch (error) {
//       console.error("Search Error:", error);
//       alert("Failed to fetch customer detailed info.");
//     }
//   };

//   // ... (handlePreviewClick, handleAction, handleDelete functions remain same)
//   const handlePreviewClick = (docImage) => {
//     if (!docImage) return;
//     setPreviewImage(`https://payyug.in/uploads/${docImage}`);
//   };

//   const handleAction = async (docId, action) => {
//     try {
//       const url =
//         action === "approved"
//           ? `https://payyug.in/api/approve-customer-kyc/${docId}`
//           : `https://payyug.in/api/reject-customer-kyc/${docId}`;
//       await axios.post(url);
//       alert(action === "approved" ? "✅ Approved!" : "❌ Rejected!");

//       if (userDetails) {
//         const res = await axios.get(`https://payyug.in/api/list-kyc`, {
//           params: {
//             userId: userDetails.userId,
//             superAdminId: userDetails.superAdminId,
//             createdId: userDetails.createdId,
//           },
//         });
//         setUploadedKyc(res.data.documents || []);
//       }
//     } catch (error) {
//       alert("Action failed.");
//     }
//   };

//   const handleDelete = async (docId) => {
//     if (!window.confirm("Are you sure?")) return;
//     try {
//       const res = await fetch(
//         `https://payyug.in/api/delete-customer-kyc/${docId}`,
//         { method: "DELETE" },
//       );
//       if (res.ok) {
//         setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));
//         alert("Deleted successfully");
//       }
//     } catch (error) {
//       alert("Error deleting document");
//     }
//   };

//   // React Select Custom Styles (Optional)
//   const customStyles = {
//     control: (base) => ({
//       ...base,
//       minWidth: "350px",
//       // height:"40px",
//       borderRadius: "4px",
//       borderColor: "#ccc",
//     }),
//   };

//   return (
//     <div className="BranchLoanKycUpload-container">
//       <h1>Customer KYC Management</h1>

//       <section className="BranchLoanKycUpload-section-filter">
//         <h2>1. Filter User</h2>
//         <div className="BranchLoanKycUpload-filter-row-wrapper">
//           <div className="BranchLoanKycUpload-filter-row">
//             {/* 2. Employee Searchable Select */}
//             <Select
//               className="Select"
//               options={employeeOptions}
//               value={selectedEmployee}
//               onChange={(option) => {
//                 setSelectedEmployee(option);
//                 setFilterValue(null); // Employee badalte hi customer select box reset ho jayega
//                 setUserDetails(null); // Input fields clear ho jayengi
//                 setUploadedKyc([]); // Table clear ho jayegi
//               }}
//               placeholder="Search Employee..."
//               isSearchable
//               // styles={customStyles}
//             />

//             {/* 3. Customer Searchable Select */}
//             <Select
//               className="Select"
//               options={customerOptions}
//               value={filterValue} // ✅ Yeh state se synced rehna chahiye
//               onChange={(option) => setFilterValue(option)}
//               placeholder="Search Customer..."
//               isSearchable
//               isDisabled={!selectedEmployee}
//               // styles={customStyles}
//             />
//           </div>
//         </div>
//         <button
//           className="c-kyc-btn-search"
//           onClick={handleSearch}
//           style={{ marginTop: "15px" }}
//         >
//           🔍 Search
//         </button>
//       </section>

//       {/* 2. User Details Section */}
//       <section className="BranchLoanKycUpload-section">
//         <h2>2. User Details</h2>
//         <div className="customer-details-wrapper">
//           <div className="customerkyc-input-groups">
//             <label>User Id</label>
//             <input type="text" value={userDetails?.userId || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Name</label>
//             <input type="text" value={userDetails?.name || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Pan Number</label>
//             <input type="text" value={userDetails?.pan || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Customer Id</label>
//             <input type="text" value={userDetails?.Id || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Aadhar Number</label>
//             <input type="text" value={userDetails?.aadhaar || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Mobile Number</label>
//             <input type="text" value={userDetails?.mobile || ""} readOnly />
//           </div>
//           <div className="customerkyc-input-groups">
//             <label>Date of Birth</label>
//             <input type="text" value={userDetails?.dob || ""} readOnly />
//           </div>
//         </div>
//       </section>

//       {/* 3. Document Table */}
//       <section className="BranchLoanKycUpload-section">
//         <h2>3. Customer KYC Document Details</h2>
//         <div className="table-wrapper">
//           <table className="BranchLoanKycUpload-table">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Document Name</th>
//                 <th>Status</th>
//                 <th>Preview</th>
//                 <th>Action</th>
//                 <th>Delete</th>
//               </tr>
//             </thead>
//             <tbody>
//               {uploadedKyc.length > 0 ? (
//                 uploadedKyc.map((doc, idx) => (
//                   <tr key={doc.id}>
//                     <td>{idx + 1}</td>
//                     <td>{doc.docName || "N/A"}</td>
//                     <td>
//                       <span
//                         className={`status-badge ${doc.status ? doc.status.toLowerCase() : "pending"}`}
//                       >
//                         {doc.status || "Pending"}
//                       </span>
//                     </td>
//                     <td>
//                       {doc.docImage ? (
//                         <button
//                           className="preview-link"
//                           onClick={() => handlePreviewClick(doc.docImage)}
//                         >
//                           Preview
//                         </button>
//                       ) : (
//                         "N/A"
//                       )}
//                     </td>
//                     <td>
//                       <button
//                         className="ckyc-btn-accept"
//                         onClick={() => handleAction(doc.id, "approved")}
//                         title="Approve"
//                       >
//                         <FontAwesomeIcon icon={faCheck} />
//                       </button>
//                       <button
//                         className="ckyc-btn-reject"
//                         onClick={() => handleAction(doc.id, "rejected")}
//                         title="Reject"
//                       >
//                         <FontAwesomeIcon icon={faTimes} />
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         className="ckyc-btn-delete"
//                         onClick={() => handleDelete(doc.id)}
//                         title="Delete"
//                       >
//                         <FontAwesomeIcon icon={faTrash} />
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="6" style={{ textAlign: "center" }}>
//                     {userDetails
//                       ? "No documents found"
//                       : "Please search a user to view documents"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </section>

//       {/* Modal Preview */}
//       {previewImage && (
//         <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <img src={previewImage} alt="KYC Preview" className="modal-image" />
//             <button
//               className="modal-close"
//               onClick={() => setPreviewImage(null)}
//             >
//               X
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import  { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import "../assets/CustomerKyc.css";
import "../css/kycformnew.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTimes,
  faTrash,
  faSearch,
  faDownload,
  faEye,
} from "@fortawesome/free-solid-svg-icons";

export default function CustomerKyc() {
  const dispatch = useDispatch();

  const [filterValue, setFilterValue] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [customerByBranch, setCustomerByBranch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { list: data } = useSelector((state) => state.employeeReport);

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
  }, [dispatch]);

  const employeeOptions = data
    ? data.map((emp) => ({
        value: emp.id,
        label: `${emp.fullName} - ${emp.id}`,
      }))
    : [];

  const customerOptions = customerByBranch.map((customer) => ({
    value: customer.userId,
    label: `${customer.fullName} - ${customer.userId}`,
  }));

  useEffect(() => {
    const fetchAllCustomersInBranch = async () => {
      if (!selectedEmployee) {
        setCustomerByBranch([]);
        setFilterValue(null);
        setUserDetails(null);
        setUploadedKyc([]);
        return;
      }

      setFilterValue(null);
      setUserDetails(null);
      setUploadedKyc([]);

      try {
        const superAdminId = localStorage.getItem("adminuserId") || "14";
        const res = await axios.get("https://payyug.in/api/customers", {
          params: {
            superAdminId,
            branchId: selectedEmployee.value,
            limit: 1000,
          },
        });
        setCustomerByBranch(res?.data?.data || []);
      } catch (err) {
        console.error("Error fetching branch customers:", err);
        setCustomerByBranch([]);
      }
    };
    fetchAllCustomersInBranch();
  }, [selectedEmployee]);

  const handleSearch = async () => {
    if (!filterValue) {
      alert("Please select a customer.");
      return;
    }

    setIsLoading(true);
    try {
      const superAdminId = localStorage.getItem("adminuserId") || "14";
      const response = await axios.get(
        "https://payyug.in/api/customers-get-userId",
        {
          params: {
            superAdminId,
            branchId: selectedEmployee.value,
            userId: filterValue.value,
          },
        }
      );

      const user = response?.data?.data;

      if (user) {
        setUserDetails({
          userId: user.userId,
          Id: user.id,
          name: user.fullName,
          pan: user.panNumber,
          aadhaar: user.aadhaarNumber,
          mobile: user.mobileNumber,
          dob: user.dateOfBirth?.slice(0, 10),
          superAdminId: user.superAdminId,
          createdId: user.branchId,
        });

        const kycResponse = await axios.get(`https://payyug.in/api/list-kyc`, {
          params: {
            userId: user.userId,
            superAdminId: user.superAdminId,
            createdId: user.branchId,
          },
        });
        setUploadedKyc(kycResponse.data.documents || []);
      } else {
        alert("Customer details not found.");
      }
    } catch (error) {
      console.error("Search Error:", error);
      alert("Failed to fetch customer detailed info.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePreviewClick = (docImage, docName) => {
    if (!docImage) return;
    setPreviewData({
      url: `https://payyug.in/uploads/${docImage}`,
      name: docName || "KYC_Document",
    });
  };

  const handleDownloadDocument = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "KYC_Document";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      window.open(fileUrl, "_blank");
    }
  };

  const handleAction = async (docId, action) => {
    try {
      const url =
        action === "approved"
          ? `https://payyug.in/api/approve-customer-kyc/${docId}`
          : `https://payyug.in/api/reject-customer-kyc/${docId}`;
      await axios.post(url);
      alert(action === "approved" ? "✅ Approved!" : "❌ Rejected!");

      if (userDetails) {
        const res = await axios.get(`https://payyug.in/api/list-kyc`, {
          params: {
            userId: userDetails.userId,
            superAdminId: userDetails.superAdminId,
            createdId: userDetails.createdId,
          },
        });
        setUploadedKyc(res.data.documents || []);
      }
    } catch (error) {
      alert("Action failed.");
    }
  };

  const handleDelete = async (docId) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res = await fetch(
        `https://payyug.in/api/delete-customer-kyc/${docId}`,
        { method: "DELETE" }
      );
      if (res.ok) {
        setUploadedKyc(uploadedKyc.filter((doc) => doc.id !== docId));
        alert("Deleted successfully");
      }
    } catch (error) {
      alert("Error deleting document");
    }
  };

  // React Select Dropdown Visibility Fix
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "38px",
      borderRadius: "4px",
      borderColor: state.isFocused ? "#2563eb" : "#cbd5e1",
      boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
      fontSize: "0.8125rem",
      backgroundColor: state.isDisabled ? "#f1f5f9" : "#ffffff",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Dropdown hamesha card/container ke upar rahega
    }),
    menu: (base) => ({
      ...base,
      fontSize: "0.8125rem",
      zIndex: 9999,
    }),
  };

  return (
    <div className="ckyc-container">
      <div className="ckyc-page-title">Customer KYC Management</div>

      {/* 1. Filter Section */}
      <div className="ckyc-card">
        <h3 className="ckyc-card-title">1. Search Customer</h3>
        <div className="ckyc-filter-row">
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Select Employee</label>
            <Select
              options={employeeOptions}
              value={selectedEmployee}
              onChange={(option) => {
                setSelectedEmployee(option);
                setFilterValue(null);
                setUserDetails(null);
                setUploadedKyc([]);
              }}
              placeholder="Select Employee..."
              isSearchable
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={selectStyles}
            />
          </div>

          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Select Customer</label>
            <Select
              options={customerOptions}
              value={filterValue}
              onChange={(option) => {
                setFilterValue(option);
                setUserDetails(null);
                 setUploadedKyc([]);
              }}
              placeholder="Select Customer..."
              isSearchable
              isDisabled={!selectedEmployee}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={selectStyles}
            />
          </div>

          <button
            className="ckyc-btn-search"
            onClick={handleSearch}
            disabled={isLoading || !filterValue}
          >
            <FontAwesomeIcon icon={faSearch} />
            <span>{isLoading ? "Searching..." : "Search"}</span>
          </button>
        </div>
      </div>

      {/* 2. User Details Section */}
      {userDetails && (
        <div className="ckyc-card">
        <h3 className="ckyc-card-title">2. Customer Details</h3>
        <div className="ckyc-details-grid">
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">User ID</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.userId || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Full Name</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.name || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Customer ID</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.Id || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">PAN Number</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.pan || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Aadhaar Number</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.aadhaar || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Mobile Number</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.mobile || ""} readOnly />
          </div>
          <div className="ckyc-form-group">
            <label className="ckyc-form-label">Date of Birth</label>
            <input className="ckyc-form-input" type="text" value={userDetails?.dob || ""} readOnly />
          </div>
        </div>
      </div>
      )}

      {/* 3. Document Verification Table */}
      {userDetails && (
        <div className="ckyc-card">
        <h3 className="ckyc-card-title">3. KYC Documents</h3>
        <div className="ckyc-table-wrap">
          <table className="ckyc-table">
            <thead>
              <tr>
                <th style={{ width: "45px" }}>#</th>
                <th>Document Name</th>
                <th style={{ width: "110px" }}>Status</th>
                <th style={{ width: "90px" }}>Preview</th>
                <th style={{ width: "100px" }}>Action</th>
                <th style={{ width: "60px", textAlign: "center" }}>Delete</th>
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => {
                  const status = (doc.status || "pending").toLowerCase();
                  return (
                    <tr key={doc.id || idx}>
                      <td>{idx + 1}</td>
                      <td>{doc.docName || "N/A"}</td>
                      <td>
                        <span className={`ckyc-badge ckyc-badge--${status}`}>
                          {doc.status || "Pending"}
                        </span>
                      </td>
                      <td>
                        {doc.docImage ? (
                          <button
                            className="ckyc-btn-link"
                            onClick={() =>
                              handlePreviewClick(doc.docImage, doc.docName)
                            }
                          >
                           <FontAwesomeIcon icon={faEye} />
                            <span>Preview</span>
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <div className="ckyc-action-btns">
                        <button
                          className="ckyc-btn-action ckyc-btn-action--approve"
                          onClick={() => handleAction(doc.id, "approved")}
                          title="Approve"
                        >
                          <FontAwesomeIcon icon={faCheck} />
                        </button>
                        <button
                          className="ckyc-btn-action ckyc-btn-action--reject"
                          onClick={() => handleAction(doc.id, "rejected")}
                          title="Reject"
                          >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                          </div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button
                          className="ckyc-btn-action ckyc-btn-action--delete"
                          onClick={() => handleDelete(doc.id)}
                          title="Delete"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="ckyc-table-empty">
                    {userDetails ? "No documents found." : "Search customer to view documents."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      )}

      {/* Preview & Download Modal */}
      {previewData && (
        <div
          className="ckyc-modal-backdrop"
          onClick={() => setPreviewData(null)}
        >
          <div
            className="ckyc-modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ckyc-modal-header">
              <h4>{previewData.name}</h4>
              <div className="ckyc-modal-actions">
                <button
                  className="ckyc-btn-download"
                  onClick={() =>
                    handleDownloadDocument(previewData.url, previewData.name)
                  }
                >
                  <FontAwesomeIcon icon={faDownload} />
                  <span>Download</span>
                </button>
                <button
                  className="ckyc-btn-close"
                  onClick={() => setPreviewData(null)}
                >
                  ✕
                </button>
              </div>
            </div>
            <div className="ckyc-modal-body">
              <img src={previewData.url} alt="Document Preview" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}